export enum VIDEO_ACTIONS {
    SET_SAVED_TEMPLATE_ID = 'SET_SAVED_TEMPLATE_ID',
    SET_BRAND_KIT_ID = 'SET_BRAND_KIT_ID',
}
